/**
 * Media type helper class
 * @constructor
 * @param {string} type - sets instace to media type
 */

// Image mime types
export const MIME_TYPE_BMP = ['image/bmp'];
export const MIME_TYPE_GIF = ['image/gif'];
export const MIME_TYPE_ICO = ['image/x-icon'];
export const MIME_TYPE_JPEG = ['image/jpeg'];
export const MIME_TYPE_PNG = ['image/png'];
export const MIME_TYPE_PSD = ['application/vnd.adobe.photoshop', 'image/vnd.adobe.photoshop', 'application/x-photoshop', 'application/photoshop', 'application/psd', 'image/psd'];
export const MIME_TYPE_SVG = ['image/svg+xml'];
export const MIME_TYPE_TIFF = ['image/tiff'];

export const MIME_TYPE_IMAGE = [
    ...new Set([
        ...MIME_TYPE_BMP,
        ...MIME_TYPE_GIF,
        ...MIME_TYPE_ICO,
        ...MIME_TYPE_JPEG,
        ...MIME_TYPE_PNG,
        ...MIME_TYPE_PSD,
        ...MIME_TYPE_SVG,
        ...MIME_TYPE_TIFF,
    ])
];

// Video mime types
export const MIME_TYPE_MP4 = ['video/mp4'];
export const MIME_TYPE_MOV = ['video/quicktime'];
export const MIME_TYPE_VIDEO = [
    ...new Set([
        ...MIME_TYPE_MP4,
        ...MIME_TYPE_MOV,
    ])
];

// Document mime types
export const MIME_TYPE_CSV = ['text/csv'];
export const MIME_TYPE_EXCEL = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
export const MIME_TYPE_PDF = ['application/pdf'];
export const MIME_TYPE_POWERPOINT = ['application/vnd.ms-powerpoint','application/vnd.openxmlformats-officedocument.presentationml.presentation'];
export const MIME_TYPE_RTF = ['application/rtf', 'application/x-rtf', 'text/rtf', 'text/richtext'];
export const MIME_TYPE_TXT = ['text/plain'];
export const MIME_TYPE_WORD = ['application/msword','application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

export const MIME_TYPE_DOCUMENT = [
    ...new Set([
        ...MIME_TYPE_CSV,
        ...MIME_TYPE_EXCEL,
        ...MIME_TYPE_PDF,
        ...MIME_TYPE_POWERPOINT,
        ...MIME_TYPE_RTF,
        ...MIME_TYPE_TXT,
        ...MIME_TYPE_WORD,
    ])
];

export const MIME_TYPE_SPREADSHEET = [
    ...new Set([
        ...MIME_TYPE_CSV,
        ...MIME_TYPE_EXCEL,
    ])
];

// audio mimetypes
export const MIME_TYPE_WAV = ['audio/wav', 'audio/vnd.wav'];
export const MIME_TYPE_M4A = ['audio/m4a'];
export const MIME_TYPE_MP3 = ['audio/mpeg'];

export const MIME_TYPE_AUDIO = [
    ...new Set([
        ...MIME_TYPE_WAV,
        ...MIME_TYPE_M4A,
        ...MIME_TYPE_MP3,
    ])
];

// Other mime types
export const MIME_TYPE_12DA = ['application/octet-stream'];
export const MIME_TYPE_3DM = ['x-world/x-3dmf'];
export const MIME_TYPE_3DMF = ['x-world/x-3dmf'];
export const MIME_TYPE_3DS = ['application/x-3ds', 'image/x-3ds'];
export const MIME_TYPE_AI = ['application/postscript', 'application/illustrator'];
export const MIME_TYPE_C4D = ['application/vnd.clonk.c4group'];
export const MIME_TYPE_DMG = ['application/octet-stream'];
export const MIME_TYPE_DWG = ['image/x-dwg', 'application/acad', 'application/dwg', 'image/vnd.dwg'];
export const MIME_TYPE_DXF = ['image/x-dxf', 'application/dxf', 'image/vnd.dxf'];
export const MIME_TYPE_ECW = ['application/octet-stream'];
export const MIME_TYPE_EPS = ['application/postscript', 'application/eps', 'application/x-eps', 'image/eps', 'image/x-eps'];
export const MIME_TYPE_FBX = ['application/octet-stream'];
export const MIME_TYPE_GEOJSON = ['application/geo+json'];
export const MIME_TYPE_INDD = ['application/x-indesign', 'application/vnd.adobe.indesign-idml-package'];
export const MIME_TYPE_JSON = ['application/json'];
export const MIME_TYPE_LAS = ['application/vnd.las'];
export const MIME_TYPE_MAX = ['application/x-3ds', 'image/x-3ds'];
export const MIME_TYPE_NWC = ['application/octet-stream'];
export const MIME_TYPE_OBJ = ['text/plain'];
export const MIME_TYPE_OTF = ['font/otf', 'font/opentype'];
export const MIME_TYPE_RVT = ['application/octet-stream'];
export const MIME_TYPE_SHP = ['application/octet-stream'];
export const MIME_TYPE_SKP = ['application/x-koan', 'application/vnd-koan', 'koan/x-skm', 'application/vnd.koan'];
export const MIME_TYPE_TTF = ['font/ttf', 'font/truetype'];
export const MIME_TYPE_WOFF = ['font/woff'];
export const MIME_TYPE_WOFF2 = ['font/woff2'];
export const MIME_TYPE_XYZ = ['application/octet-stream'];
export const MIME_TYPE_ZIP = ['application/zip', 'application/x-compressed', 'application/x-zip-compressed', 'multipart/x-zip'];

export const MIME_TYPE_OTHER = [
    ...new Set([
        ...MIME_TYPE_12DA,
        ...MIME_TYPE_3DM,
        ...MIME_TYPE_3DMF,
        ...MIME_TYPE_3DS,
        ...MIME_TYPE_AI,
        ...MIME_TYPE_C4D,
        ...MIME_TYPE_DMG,
        ...MIME_TYPE_DWG,
        ...MIME_TYPE_DXF,
        ...MIME_TYPE_ECW,
        ...MIME_TYPE_EPS,
        ...MIME_TYPE_FBX,
        ...MIME_TYPE_GEOJSON,
        ...MIME_TYPE_INDD,
        ...MIME_TYPE_JSON,
        ...MIME_TYPE_LAS,
        ...MIME_TYPE_MAX,
        ...MIME_TYPE_NWC,
        ...MIME_TYPE_OBJ,
        ...MIME_TYPE_OTF,
        ...MIME_TYPE_RVT,
        ...MIME_TYPE_SHP,
        ...MIME_TYPE_SKP,
        ...MIME_TYPE_TTF,
        ...MIME_TYPE_WOFF,
        ...MIME_TYPE_WOFF2,
        ...MIME_TYPE_XYZ,
        ...MIME_TYPE_ZIP,
    ])
];

export const ALL_MIME_TYPES = [
    ...new Set([
        ...MIME_TYPE_IMAGE,
        ...MIME_TYPE_VIDEO,
        ...MIME_TYPE_DOCUMENT,
        ...MIME_TYPE_AUDIO,
        ...MIME_TYPE_OTHER,
    ])
]

export const EXT_MIME_TYPE_MAP = {
    '12da': 'application/octet-stream',
    '3dm': 'x-world/x-3dmf',
    '3dmf': 'x-world/x-3dmf',
    '3ds': 'application/x-3ds',
    ai: 'application/postscript',
    bmp: 'image/bmp',
    c4d: 'application/vnd.clonk.c4group',
    csv: 'text/csv',
    dmg: 'application/octet-stream',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    dwg: 'image/vnd.dwg',
    dxf: 'image/vnd.dxf',
    ecw: 'application/octet-stream',
    eps: 'application/postscript',
    fbx: 'application/octet-stream',
    gif: 'image/gif',
    ico: 'image/x-icon',
    indd: 'application/x-indesign',
    jpeg: 'image/jpeg',
    jpg: 'image/jpeg',
    las: 'application/vnd.las',
    m4a: 'audio/m4a',
    max: 'application/x-3ds',
    mov: 'video/quicktime',
    mp3: 'audio/mpeg',
    mp4: 'video/mp4',
    nwc: 'application/octet-stream',
    obj: 'text/plain',
    otf: 'font/otf',
    pdf: 'application/pdf',
    png: 'image/png',
    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    psd: 'application/vnd.adobe.photoshop',
    rtf: 'application/rtf',
    rvt: 'application/octet-stream',
    shp: 'application/octet-stream',
    skp: 'application/x-koan',
    svg: 'image/svg+xml',
    tiff: 'image/tiff',
    ttf: 'font/ttf',
    txt: 'text/plain',
    wav: 'audio/wav',
    woff: 'font/woff',
    woff2: 'font/woff2',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    xyz: 'application/octet-stream',
    zip: 'application/zip',
};
export default class MediaType {
    
    constructor(type = null) {
        // type is optional may want to use class and manually set.

        this.types = {
            image: {
                mimetypes: [...MIME_TYPE_IMAGE],
                extensions: ['jpg', 'jpeg', 'png', 'gif', 'psd', 'ico', 'tiff', 'bmp', 'svg'],
            },
            video: {
                mimetypes: [...MIME_TYPE_VIDEO],
                extensions: ['mp4', 'mov'],
            },
            document: {
                mimetypes: [...MIME_TYPE_DOCUMENT],
                extensions: ['pdf', 'doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'csv', 'txt', 'rtf'],
            },
            audio: {
                mimetypes: [...MIME_TYPE_AUDIO],
                extensions: ['wav', 'm4a', 'mp3'],
            },
            other: {
                mimetypes: [...MIME_TYPE_OTHER],
                extensions: [
                    '12da',
                    '3dm',
                    '3dmf',
                    '3ds',
                    'ai',
                    'c4d',
                    'dmg', 
                    'dwg', 
                    'dxf', 
                    'ecw',
                    'eps',
                    'fbx',
                    'geojson',
                    'indd',
                    'json', 
                    'las',
                    'max',
                    'nwc',
                    'obj',
                    'otf',
                    'rvt',
                    'shp',
                    'skp',
                    'ttf',
                    'woff',
                    'woff2',
                    'xyz',
                    'zip', 
                ],
            },
        };

        if (type && mediaTypes.includes(type)) {
            this.setType(type);
        }
    }

    /**
     * returns the current media type
     * @returns {string} a media type
     */
    getType() {
        return this.type;
    }

    /**
     * returns all media types
     * @returns {array} media types
     */
    getTypes() {
        return Object.keys(this.types);
    }

    /**
     * returns all media mime types for current type
     * @returns {array} media types
     */
    getMimeTypes() {
        return this.types[this.type].mimetypes;
    }

    /**
     * returns a comma separated string of mime types for current type
     * @returns {string} mime types string
     */
    getMimeTypesString() {
        const types = [];
        for (let prop in this.types) {
            types.concat(this.types[prop].mimetypes);
        }
        return types.join(',');
    }

    /**
     * returns an array of mime types for specified media types
     * @param {array} types - an array of media types
     * @returns {array} mime types 
     */
    getMimeTypesForTypes(types) {
        let mimetypes = [];
        types.forEach((key, value) => {
            this.type = key;
            mimetypes.push(this.getMimeTypes());
        });
        return mimetypes;
    }

    /**
     * returns the media type a given extension belongs to
     * @param {string} ext - a file extension
     * @returns {string} media type
     */
    getTypeFromExtension(ext) {
        for (let type in this.types) {
            if (this.types[type].extensions.includes(ext)) {
                return type;
            }
        }
    }

    /**
     * returns the media type a given mime type belongs to
     * @param {string} mimeType - a mime type
     * @returns {string} media type
     */
    getTypeFromMimeType(mimeType) {
        for (let type in this.types) {
            if (this.types[type].mimetypes.includes(mimeType)) {
                return type;
            }
        }
    }

    /**
     * sets the current media type 
     * @param {string} type - a media type
     */
    setType(type) {
        this.type = type;
    }

    /**
     * returns mime type from file extension
     * @param {string} ext - a file extension
     */
    getMimeTypeFromExtension(ext) {
        let mimeType = false;
        if (EXT_MIME_TYPE_MAP.hasOwnProperty(ext)) {
            mimeType = EXT_MIME_TYPE_MAP[ext];
        } 
        return mimeType;
    }
}
